<div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.addtional_service && serviceTypes && serviceStatuses && items">
    <div class="center" style="text-align: right;">
        <button type="button" class="button_icon button_icon_color" (click)="onLoad()">replay_circle_filled</button>
    </div>
    <i class="material-icons on_language_changed" style="float:left;" (click)="onLoad()"></i>
    <div class="banner center" style="margin-top: 10px; max-width: 600px;" *ngFor="let item of items">
        <div>
            <label>{{localService.getText(serviceTypes,item.v1)}}</label>
        </div>
        <div style="text-align: justify;">
            {{getServiceStatus(item.v2,item.v3 | localDate)}}
        </div>
        <div style="text-align: right;" *ngIf="localService.isUserHasBusinessRole(businessId,RelationShipRole.Admin)">
            <button type="button" class="btn btn-primary" style="margin:5px;" (click)="onAction(1,item.v1)"
                *ngIf="item.v2 != '1' && item.v2 != '2' && item.v2 != '5'">{{localService.languageContent.common.activate}}</button>
            <button type="button" class="btn btn-primary" style="margin:5px;" (click)="onAction(2,item.v1)"
                *ngIf="item.v2 != '1' && item.v2 != '3' && item.v2 != '4'">{{localService.languageContent.common.deactivate}}</button>
        </div>
    </div>
</div>